import { PageType } from "../../../constants/types.constants";
import { BirthPageEntity } from "../entities/birth-page.entity";

export interface Params {
  id: number;
  imageName: string;
  headLine: string;
  description: string;
  type: PageType;
  createdAt: string;
  updatedAt: string;
}

export class BirthPageModel {
  id: number;
  imageName: string;
  headLine: string;
  description: string;
  type: PageType;
  createdAt: string;
  updatedAt: string;

  constructor(params: Params) {
    this.id = params.id;
    this.imageName = params.imageName;
    this.headLine = params.headLine;
    this.description = params.description;
    this.type = params.type;
    this.createdAt = params.createdAt;
    this.updatedAt = params.updatedAt;
  }

  toEntity(): BirthPageEntity {
    return {
      id: this.id,
      imageName: this.imageName,
      headLine: this.headLine,
      description: this.description,
      type: this.type,
      createdAt: this.createdAt,
      updatedAt: this.updatedAt,
    };
  }
}
